export default "__VITE_ASSET__3b0e4194__"